import PageLayoutProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/page-layout";
import BannerProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/banner";
import TopNavigationProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/top-navigation";
import MainProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/main";
import ContentProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/content";
import LeftSidebarProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/left-sidebar";
import LeftSidebarWithoutResizeProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/left-sidebar-without-resize";
import RightSidebarProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/right-sidebar";
import LeftPanelProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/left-panel";
import RightPanelProps from "!!extract-react-types-loader!../../../../../../packages/design-system/page-layout/src/components/slots/right-panel";
import * as React from 'react';
export default {
  PageLayoutProps,
  BannerProps,
  TopNavigationProps,
  MainProps,
  ContentProps,
  LeftSidebarProps,
  LeftSidebarWithoutResizeProps,
  RightSidebarProps,
  LeftPanelProps,
  RightPanelProps,
  React
};